import { render, staticRenderFns } from "./examfooter.vue?vue&type=template&id=01f3f582&scoped=true&"
import script from "./examfooter.vue?vue&type=script&lang=js&"
export * from "./examfooter.vue?vue&type=script&lang=js&"
import style0 from "./examfooter.vue?vue&type=style&index=0&id=01f3f582&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f3f582",
  null
  
)

export default component.exports